import React from 'react'
import PropTypes from 'prop-types'

import { nonAcceptedFoiStatuses, responsePageReadOnlyStatuses } from '../../util/foiConsts'
import { FlexColumn, LightBGContainer, SpaceBetweenRowContainer } from '../styles/Containers'
import { BoldFormTitle } from '../styles/Text'
import SentBillTable from '../billingTables/SentBillTable'
import DraftBillTable from '../billingTables/DraftBillTable'
import NewBillButton from '../bill/NewBillButton'

function BillingTab({
  foiId,
  foiStatus,
  bills = [],
  users = [],
  requestorEmail = '',
  editingBill,
  expandedBillId,
  onBillUpdate = () => {},
  handleUpdateEditingBill = () => {}
}) {
  const draftBills = bills.filter(b => b.billState === 'DRAFT')
  const sentBills = bills.filter(b => b.billState === 'SENT')

  return (
    <FlexColumn>
      <LightBGContainer padding="20px 30px 30px">
        <FlexColumn>
          <SpaceBetweenRowContainer>
            <BoldFormTitle>Drafts</BoldFormTitle>
            {!responsePageReadOnlyStatuses.includes(foiStatus) && (
              <NewBillButton foiId={foiId} onSuccess={onBillUpdate} onlyApplicationFeeAllowed={nonAcceptedFoiStatuses.includes(foiStatus)} />
            )}
          </SpaceBetweenRowContainer>
          <DraftBillTable
            bills={draftBills}
            users={users}
            onlyApplicationFeeAllowed={nonAcceptedFoiStatuses.includes(foiStatus)}
            onBillUpdate={onBillUpdate}
            editingBill={editingBill}
            expandedBillId={expandedBillId}
            handleUpdateEditingBill={handleUpdateEditingBill}
          />
        </FlexColumn>
      </LightBGContainer>
      <LightBGContainer padding="30px">
        <FlexColumn>
          <BoldFormTitle>History</BoldFormTitle>
          <SentBillTable bills={sentBills} requestorEmail={requestorEmail} onBillUpdate={onBillUpdate} />
        </FlexColumn>
      </LightBGContainer>
    </FlexColumn>
  )
}

BillingTab.propTypes = {
  foiId: PropTypes.string.isRequired,
  foiStatus: PropTypes.string.isRequired,
  bills: PropTypes.array,
  users: PropTypes.array,
  requestorEmail: PropTypes.string,
  editingBill: PropTypes.object,
  expandedBillId: PropTypes.string,
  onBillUpdate: PropTypes.func,
  handleUpdateEditingBill: PropTypes.func
}

export default BillingTab
